import React from 'react';
import Layout from '../components/layout/Layout';
import RoleRoute from './RoleRoute';

const RoleLayout: React.FC = () => (
  <RoleRoute>
    <Layout />
  </RoleRoute>
);

export default RoleLayout;
